const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Presentation-Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Presentations} Presentations the resource defined to manage presenations
 */
app.directive('presentationViewer', ['Application', 'Authorization', 'Analyze', 'Presentations', 'ContentAuth', '$translate', function (Application, Authorization, Analyze, Presentations, ContentAuth, $translate) {
  return {
    restrict: 'E',
    scope: {
      checkFull: '@',
      fullData: '=',
      onComplete: '&',
      contentId: '='
    },
    template: require('../../templates/directives/presentation-viewer.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      var adminRoles = ['admin', 'creator'];
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = adminRoles.indexOf(self.user.role) !== -1;
      self.type = 'presentation';
      self.presentation = {};

      self.setInitials = function() {
        self.routeParameters = Application.navigation.getRouteParameters();
        self.url = Application.navigation.getUrl();
        self.inTrack = new RegExp('track').test(self.url);
        self.inEditing = new RegExp('edit').test(self.url);
        self.contentId = $scope.contentId || self.routeParameters.id || null;
        self.presentation = {};
      };
      self.setInitials();

      self.displayTime = function(time) {
        var mins = ~~(time / 60);
        var secs = time % 60;

        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = time % 60;

        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
        }

        ret += "" + mins + (mins === 1 ? " min" : " mins");
        return ret;
      };

      self.addDurationWatch = function(get) {
        if (!get) {
          $scope.$watch('fullData.duration', function(newVal, oldVal) {
            if (newVal === oldVal) {
              return;
            }
            self.presentation.duration = $scope.fullData.duration;
          });
          return;
        }
        $scope.$watch('presentation.presentation.duration', function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          self.presentation.duration = self.presentation.duration;
        });
      };

      var setFull = function() {
        self.presentation = $scope.fullData;
        if (Application.navigation.getUrl().indexOf('edit') !== -1) {
          self.addDurationWatch();
        }
      };
      self.initialize = function () {
        if (!self.contentId && !$scope.fullData) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }

        if ($scope.checkFull) {
          if ($scope.fullData) {
            setFull();
            return;
          }
          var fullWatch = $scope.$watch('fullData', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              setFull();
              fullWatch();
            }
          }, true);
          return;
        }

        Presentations.get({
          subresource: self.contentId, 
          fields: 'title,description,author,banner_image,user,duration,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private',
          'user-populate': 'first_name,last_name,email'
        }, function (data) {
          ContentAuth.allowView(data).then(function(allowed) {
            if(!allowed) {
              Application.messaging.addMessage({type: 'error', text: self.translations['presentation.viewer.permission_error'], duration: 5});
              Application.navigation.back();
              return;
            }
            Analyze.record({resource: 'views'}, {content: data._id, content_type: 'presentation'});
            Application.analyticsProvider.trackEvent('presentation_viewed', {content: data._id, content_type: 'presentation', title: data.title});
            self.presentation = data;
            $window.document.title = self.presentation.title;
            if ($scope.onComplete) {
              $scope.onComplete();
            } else if (self.inTrack) {
              var completeWatch = $scope.$watch('onComplete', function(newVal, oldVal){
                if (newVal && !oldVal) {
                  $scope.onComplete();
                  completeWatch();
                }
              });
            }
            if (Application.navigation.getUrl().indexOf('edit') !== -1) {
              self.addDurationWatch();
            }
          });
        }, function (error) {

          console.log('Error occured getting presentation ', self.contentId, error);
          Application.notifications.setError(self.translations['modules.notifications.unableToGetArticle']);
        });

      };
      self.image = function () {
        if (self.presentation.banner_image || self.presentation.image) {
          var imageUrl = self.presentation.banner_image ? self.presentation.banner_image : self.presentation.image;
          return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
        }
        return '//placehold.it/800x550';
      };

      $translate([
        'modules.notifications.unableToGetArticle',
        'edit.article.lessThanAMinute',
        'presentation.viewer.permission_error'
      ]).then(function(translations){
        self.translations = translations;
        self.initialize();
      });

      $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.setInitials();
        self.initialize();
      });

    }],
    controllerAs: 'viewer'
  };
}]);
